module.exports = __webpack_public_path__ + "img/360-montering-2.022c9a0e.jpg";